export const NO_CAPABILITIES = {
    canEdit: false,
    canViewSensitive: false,
    canRecordGoNoGo: false,
    canConvertToProposal: false,
    canCreatePursuit: false,
    canSetGrowthHint: false,
    canWriteEvents: false
};
/** The wire response as the browser shape (capabilities always set). */ export function toPursuitHeader(response) {
    return {
        ...response,
        capabilities: response.capabilities ?? NO_CAPABILITIES
    };
}
export { ThreadGroup } from '../../../../../../gen/ts/mono/projectdata/v1/pursuit_read_pb';
